import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CLIENT_CASE_STUDIES } from '../client-case-studies';
import { ClientCaseStudyComponent } from '../shared/client-case-study/client-case-study.component';

@Component({
  selector: 'app-citibanamex',
  standalone: true,
  imports: [CommonModule, ClientCaseStudyComponent],
  templateUrl: './citibanamex.component.html',
  styleUrl: './citibanamex.component.scss'
})
export class CitibanamexComponent {
  readonly caseStudy = CLIENT_CASE_STUDIES.citibanamex;
}
